import React, { useState } from 'react';
import GreenImage from '../images/team-icons/S2_ActiveTeam_Green.png';
import BlueImage from '../images/team-icons/S2_ActiveTeam_Blue.png';
import YellowImage from '../images/team-icons/S2_ActiveTeam_Yellow.png';
import PurpleImage from '../images/team-icons/S2_ActiveTeam_Purple.png';
import BlackImage from '../images/team-icons/S2_ActiveTeam_Black.png';
import RedImage from '../images/team-icons/S2_ActiveTeam_Red.png';
import { Button, TextInput } from '@prosolve/common-components-ui'
// import PdColorPicker from './PdColorPicker'

export default ({
  onTeamDataSelected
}) => {
  const [selectedTeamColor, setSelectedTeamColor] = useState('')
  const [teamName, setTeamName] = useState('')

  // const [view, setView] = useState('welcome')
  const [view, setView] = useState('teamSelect')

  const colorImageMap = {
    Green: GreenImage,
    Blue: BlueImage,
    Yellow: YellowImage,
    Purple: PurpleImage,
    Black: BlackImage,
    Red: RedImage
  }

  const buttonStyle = {
    display: 'inline-flex',
    marginRight: '10px',
    // fontWeight: 'bold',
    fontSize: '24px',
    width: '150px',
    height: '40px',
    background: 'transparent'
  }

  const onTeamSubmit = () => {
    if (Boolean(selectedTeamColor) && Boolean(teamName) ) {
      onTeamDataSelected(selectedTeamColor.replace(/^#/, ""), teamName)
      // setView('eleanorLink')
      window.location.reload();
    }
  }

  const onOpenEleanorLink = () => {
    const linkUrl = 'https://chatgpt.com/g/g-6941d2c4491c8191a3c57b826cd0c2a6-eleanor-the-predictor';
    // const linkUrl = 'https://chatgpt.com/g/g-69110817385481919c0bbf67254212b8-eleanor-the-predictor-v2'
    window.open(linkUrl, '_blank')
    // todo can improve this but good enough for now
    window.location.reload();
  }

  if (view === 'welcome') {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 60px)',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'transparent',
        overflow: 'auto',
        gap: '40px',
        color: '#c7ffff',
        fontFamily: '"PassionOne-Regular", "Open Sans", sans-serif'
      }}>
        <div style={{
          color: '#c7ffff',
          // fontWeight: 'bold',
          fontSize: '48px'
        }}>
          {'Prepare for Eleanor to take you on your experience'}
        </div>
        <Button
          style={buttonStyle}
          onClick={() => setView('teamSelect')}
          $colored={true}
        >
          {'Proceed'}
        </Button>
      </div>
    )
  } else if (view === 'teamSelect') {
    return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'transparent',
      fontFamily: '"PassionOne-Regular", "Open Sans", sans-serif',
      overflow: 'auto',
      marginTop: '60px' // '100px'
    }}>
      <div style={{
        color: '#c7ffff',
        // fontWeight: 'bold',
        fontSize: '48px',
        // marginBottom: '40px'
      }}>
        {'Select Your Team Color and Name!'}
      </div>
      {/* <PdColorPicker value={selectedTeamColor} onChange={setSelectedTeamColor} /> */}
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        rowGap: '10px',
        columnGap: '10px',
        justifyContent: 'center',
        margin: '40px 0px'
      }}>
        {
          Object.keys(colorImageMap).map(color => {
            const colorImage = colorImageMap[color];
            return (
              <div
                key={color}
                onClick={() => setSelectedTeamColor(color)}
                style={{
                  cursor: 'pointer',
                  border: selectedTeamColor === color ? '6px solid #56a83f' : '6px solid transparent',
                  borderRadius: '50%',
                  padding: '10px 2px 0px 2px'
                }}
              >
                <img src={colorImage} style={{ height: '200px' }} alt={`team-color-${color}`} />
              </div>
            )
          })
        }
      </div>
      <TextInput
        width='400px'
        style={{ marginBottom: '40px', marginTop: '20px' }}
        value={teamName}
        onChange={(val) => setTeamName(val)}
        placeholder='Team Name'
      />
      <Button
        style={buttonStyle}
        onClick={onTeamSubmit}
        $colored={true}
        $disabled={!(Boolean(selectedTeamColor) && Boolean(teamName))}
      >
        {'SUBMIT'}
      </Button>
    </div>
    )
  } else {
        return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 60px)',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'transparent',
        overflow: 'auto',
        fontFamily: '"PassionOne-Regular", "Open Sans", sans-serif',
        gap: '40px'
      }}>
        <div style={{
          color: '#c7ffff',
          // fontWeight: 'bold',
          fontSize: '48px'
        }}>
          {'Click below to open Eleanor in a new tab'}
        </div>
        <div style={{
          color: '#c7ffff',
          fontSize: '16px'
        }}>
          {'After you have opened Eleanor in a new tab, keep Eleanor open but please return to this tab to continue the experience'}
        </div>
        <Button
          style={buttonStyle}
          onClick={onOpenEleanorLink}
          $colored={true}
        >
          {'Open Eleanor'}
        </Button>
      </div>
    )
  }
}